import React from "react";
import "./LibraryChapter.css";
import axios from "../../../../axios";
export default function DeleteBookmark({
  handleCloseBookmarkDeltePopup,
  data,
  userData,
  contentId,
  reRenderPage,
}) {
  // console.log(data);
  const handleDelete = async () => {
    let res = await axios.delete(
      `/cm/library/book/deleteUserBookmarksByUserIDAndContentInfoID?user_id=${userData?.id}&contentInfo_id=${contentId}&bookmark_id=${data?.id}`
    );
    if (res.status === 200) {
      // window.location.reload();
      reRenderPage();
      handleCloseBookmarkDeltePopup();
    }
  };
  return (
    <div>
      <div className="ContainerDeletePop">
        <div className="SubContainerDeletePop ">
          <div className="d-flex justify-content-center deleteMsg">
            Are you sure you want to Delete this Bookmark?
          </div>
          <div className="d-flex gap-3 mt-3 justify-content-center">
            <button
              className="DeleteYesBtn"
              onClick={() => {
                handleDelete();
              }}
            >
              Yes
            </button>
            <button
              className="DeleteYesBtn"
              onClick={() => {
                handleCloseBookmarkDeltePopup();
              }}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
